import { createSlice } from '@reduxjs/toolkit';

import type { User } from "@/redux/type";


interface AuthResponse {
  token: string | null;
  user: User | null;
}

const initialState: AuthResponse = {
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;